import { CaseStatus, CaseType } from 'types'

export const DEFAULT_CASE_TYPES: CaseType[] = [
  'Issue',
  'Deliverable',
  'Support',
] as CaseType[]

export const DEFAULT_CASE_STATUSES: CaseStatus[] = [
  'Open',
  'In Progress',
  'Closed',
] as CaseStatus[]

export const DEFAULT_CASE_TITLE = 'Untitled Case'
